import {  LitElement, css, html, TemplateResult } from "lit";
import {property, customElement} from 'lit/decorators.js';
import { ValidatonErrors } from "./voyage-route-editor";

@customElement("voy-route-editor-validation-errors")
export class VoyRouteEditorValidationErrors extends LitElement {
    @property({ type: Object })
    public errors: ValidatonErrors = new Map();

    static get styles() {
        return [
            css`
                .validation-errors {
                    padding: 14px;
                }
                .validation-errors h3 {
                    font-family: MaerskText;
                    font-size: 16px;
                    line-height: 24px;
                    letter-spacing: 0em;
                    text-align: left;
                    color: var(--waypoint-editor-coordinates-text, black);
                    text-transform: capitalize;
                }
                .validation-errors p {
                    font-size: 14px;
                    color: var(--neutrals-grey-02, black);
                    font-family: MaerskText;
                }
        `];
    }

    render() {
        const errorMessages: TemplateResult[] = [];

        for (const [type, map] of this.errors!.entries()) {
            if (map.size === 0) continue;

            const messages = Array.from(map.values()).map(message => html`<p>${message}</p>`)
            errorMessages.push(html`
                <div id=${type}>
                    <h3>${type.replace("-", " ")}</h3>
                    ${messages}
                </div>
            `)
        }

        return html`
            <div class="validation-errors">${errorMessages}</div>
        `
    }
}
